"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RxIf = void 0;
const react_1 = __importDefault(require("react"));
const use_rx_1 = require("./use-rx");
function RxIf({ test$, children, negate, else: not }) {
    const raw = use_rx_1.useRx(test$);
    const truthy = raw.status === "fulfilled" && Boolean(raw.value);
    if (negate && !truthy) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    else if (negate) {
        if (typeof not === "function")
            return react_1.default.createElement(react_1.default.Fragment, null, not());
        else
            return react_1.default.createElement(react_1.default.Fragment, null, not);
    }
    else if (truthy) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    else {
        if (typeof not === "function")
            return react_1.default.createElement(react_1.default.Fragment, null, not());
        else
            return react_1.default.createElement(react_1.default.Fragment, null, not);
    }
}
exports.RxIf = RxIf;
